import { render, staticRenderFns } from "./JasaEmas.vue?vue&type=template&id=bbb7f22a&"
import script from "./JasaEmas.vue?vue&type=script&lang=js&"
export * from "./JasaEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports